// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./rvw_integrations_core/cartridges/rvw_integrations_core/cartridge/client/default/js/productDetail.js");
